import InvoiceTable from './InvoiceTable';
import React from 'react';

import './Invoice.scss';

const Invoice = props => {
    return (
        <div className="invoice-wrapper">
            <InvoiceTable />
        </div>
    );
};

export default Invoice;
